"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initSharingModule = initSharingModule;
const apiService_1 = require("./apiService");
const cache_1 = require("./cache");
const cryptoService_1 = require("./cryptoService");
const events_1 = require("./events");
const sharingAccess_1 = require("./sharingAccess");
const sharingManagement_1 = require("./sharingManagement");
/**
 * Provides facade for the whole sharing module.
 *
 * The sharing module is responsible for handling invitations, bookmarks,
 * standard shares, listing shared nodes, etc. It includes API communication,
 * encryption, decryption, caching, and event handling.
 */
function initSharingModule(telemetry, apiService, driveEntitiesCache, account, crypto, driveEvents, sharesService, nodesService, nodesEvents) {
    const api = new apiService_1.SharingAPIService(telemetry.getLogger('sharing-api'), apiService);
    const cache = new cache_1.SharingCache(driveEntitiesCache);
    const cryptoService = new cryptoService_1.SharingCryptoService(crypto, account);
    const sharingAccess = new sharingAccess_1.SharingAccess(api, cache, cryptoService, sharesService, nodesService);
    const sharingEvents = new events_1.SharingEvents(telemetry.getLogger('sharing-events'), driveEvents, cache, nodesService, sharingAccess);
    const sharingManagement = new sharingManagement_1.SharingManagement(telemetry.getLogger('sharing'), api, cryptoService, account, sharesService, nodesService, nodesEvents);
    return {
        access: sharingAccess,
        events: sharingEvents,
        management: sharingManagement,
    };
}
//# sourceMappingURL=index.js.map